import { Box, BoxProps, Button, IconProp } from '@ff-it/ui';
import { ReactElement } from 'react';

export type ChipTrayProps = {
  disabled?: boolean;
} & BoxProps;

// A wrapping row of chips, bordered like an input.
export function ChipTray({ disabled, children, ...rest }: ChipTrayProps): ReactElement {
  return (
    <Box
      display="flex"
      flexDirection="row"
      borderRadius="xs"
      gap="1"
      border="default"
      py="1"
      px="2"
      justifyContent="flex-start"
      flexWrap="wrap"
      background={disabled ? 'gray100' : undefined}
      {...rest}
      aria-disabled={disabled}
    >
      {children}
    </Box>
  );
}

export type SelectionChipProps = {
  onRemove?: () => void;
  removeIcon?: IconProp;
  disabled?: boolean;
} & BoxProps;

// A single chip holding arbitrary content with an optional remove button.
export function SelectionChip({
  onRemove,
  removeIcon = 'xmark',
  disabled,
  children,
  ...rest
}: SelectionChipProps): ReactElement {
  return (
    <Box display="inline-flex" flexDirection="row" gap="2" border="default" py="1" px="2" borderRadius="xs" {...rest}>
      {children}
      {onRemove && <Button disabled={disabled} icon={removeIcon} variant="secondary" size="xxs" onClick={onRemove} />}
    </Box>
  );
}
